import React from "react";
import TopSection from "../TopSection/TopSection";
import Favourites from "../Favourites/Favourites";
import StepsScreen from "../StepsScreen/StepsScreen";
import CustomerOrder from "../CustomerOrder/CustomerOrder";
import ImageSection from "../ImageSection/ImageSection";
import Form from "../Form/Form";
import ProductDescription from "../ProductDescription/ProductDescription";
import OwnerSection from "../OwnerSection/OwnerSection";
import StandeeFeatures from "../Standee/StandeeFeatures";

const Home = () => {
  return (
    <div>
      <div>
        <TopSection />
        <Favourites />
        <StepsScreen />
        <CustomerOrder />
        <StandeeFeatures />
        <ImageSection />
        <OwnerSection />       
      </div>
    </div>
  );
};

export default Home;
